module.exports = __webpack_public_path__ + "static/media/ic-edit.033fbf22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-edit.svg
// module id = 625
// module chunks = 14